const initState = {
    posts: [
        {id: '1', title: 'help me find my peach', content: 'blah blah blah'},
        {id: '2', title: 'collect all the stars', content: 'blah blah blah'},
        {id: '3', title: 'egg hunt with yoshi', content: 'blah blah blah'}
    ]
};

const postReducer = (state = initState, action) => {

    switch (action.type) {
        case 'CREATE_POST':
            console.log('Created post', action.post);
            console.log('Created post state', state);
            return state;
        case 'CREATE_POST_ERROR':
            console.log('Create post error', action.err);
            return state;
        case 'DELETE_POST':
            console.log('Delete post');
            return state;
        case 'DELETE_POST_ERROR':
            console.log('Create post error', action.err);
            return state;
        default:
            return state;
    }
};

export default postReducer;